module.exports = __webpack_public_path__ + "f62e8dff3c0fef33e291fa61de681d6f.png";